<template>
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="Arrow" fill-rule="evenodd" clip-rule="evenodd"
            d="M13.7489 0.26035C14.0837 0.607482 14.0837 1.1703 13.7489 1.51743L7.74895 7.73965C7.41421 8.08678 6.8715 8.08678 6.53676 7.73965L0.536764 1.51743C0.202029 1.1703 0.202029 0.607482 0.536764 0.260349C0.871499 -0.0867838 1.41421 -0.0867838 1.74895 0.260349L7.14286 5.85403L12.5368 0.26035C12.8715 -0.0867833 13.4142 -0.0867832 13.7489 0.26035Z"
            fill="#133459" />
    </svg>
</template>